import { HttpMethod } from '@nu-art/thunderstorm-shared';
export const ApiDef_User = {
    _v1: {
        getMyUser: { method: HttpMethod.GET, path: '/v1/user/me' },
    }
};
//# sourceMappingURL=api-def.js.map